export default __webpack_public_path__ + "static/media/ReasonTypes.fb7d857b.xlsx";